import React from "react";

const GAMES = [
  {
    id: "pong",
    icon: "🏓",
    title: "Pong",
    description: "Two-paddle classic. Python - pygame, compiled to WebAssembly. Desktop only.",
    controls: "W / S : left paddle   |   ↑ / ↓ : right paddle",
  },
];

const GameHubWindow = ({ navigate }) => {
  return (
    <div className="flex h-full flex-col bg-[#c0c0c0] font-ui text-win-text">
      <div className="win-sunken-thin m-2 flex items-center gap-2 px-2 py-1 text-xs">
        <span aria-hidden="true">🕹️</span>
        C:\JAKOB\GAMES ({GAMES.length} item{GAMES.length === 1 ? "" : "s"})
      </div>

      <div className="flex-1 space-y-3 overflow-auto px-2 pb-2">
        {GAMES.map((game) => (
          <article key={game.id} className="win-raised flex flex-wrap items-center gap-4 p-3">
            <span className="text-4xl" aria-hidden="true">{game.icon}</span>
            <div className="min-w-[200px] flex-1">
              <h3 className="text-lg font-black">{game.title}</h3>
              <p className="mt-1 text-xs leading-5">{game.description}</p>
              <p className="mt-1 text-[11px] text-[#404040]">{game.controls}</p>
            </div>
            <button
              type="button"
              onClick={() => navigate(game.id)}
              className="win-btn win-focus-dotted shrink-0 px-4 py-2 text-sm font-bold"
            >
              ▶ Play
            </button>
          </article>
        ))}

        <p className="px-1 text-[11px] italic text-[#404040]">More games get added here as I build them.</p>
      </div>
    </div>
  );
};

export default GameHubWindow;
